import { Link } from 'react-router-dom';

interface ComicCardProps {
  id: number;
  title: string;
  author: string;
  coverImage: string;
  rating: number;
  views: number;
  status: string;
  tags: string[];
  category: string;
  size?: 'default' | 'large';
}

function formatViews(views: number): string {
  if (views >= 1000000) return `${(views / 1000000).toFixed(1)}M`;
  if (views >= 1000) return `${(views / 1000).toFixed(0)}K`;
  return String(views);
}

export default function ComicCard({
  id, title, author, coverImage, rating, views, status, tags, size = 'default',
}: ComicCardProps) {
  const isLarge = size === 'large';

  return (
    <Link
      to={`/comic/${id}`}
      className="group block cursor-pointer"
      data-product-shop
    >
      <div className="relative overflow-hidden rounded-xl bg-background-100">
        <div
          className="w-full overflow-hidden"
          style={{ aspectRatio: isLarge ? '3/4' : '2/3' }}
        >
          <img
            src={coverImage}
            alt={title}
            title={`${title} - 免费韩漫在线观看`}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          />
        </div>
        {status === '已完结' && (
          <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full text-xs font-medium bg-background-50/90 text-foreground-700">
            {status}
          </span>
        )}
        {status === '连载中' && (
          <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full text-xs font-medium bg-primary-500 text-background-50">
            {status}
          </span>
        )}
        <div className="absolute top-3 right-3 flex items-center gap-1 px-2 py-1 rounded-full bg-background-50/90">
          <div className="w-3.5 h-3.5 flex items-center justify-center">
            <i className="ri-star-fill text-accent-500 text-xs"></i>
          </div>
          <span className="text-xs font-semibold text-foreground-900">{rating}</span>
        </div>
      </div>

      <div className="mt-3 px-1">
        <h3 className="font-heading text-sm font-semibold text-foreground-950 line-clamp-1 group-hover:text-primary-600 transition-colors">
          {title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1">{author}</p>
        <div className="flex items-center gap-3 mt-2">
          <span className="flex items-center gap-1 text-xs text-foreground-400">
            <div className="w-3.5 h-3.5 flex items-center justify-center">
              <i className="ri-eye-line text-foreground-400 text-xs"></i>
            </div>
            {formatViews(views)}
          </span>
          {tags.slice(0, 2).map((tag) => (
            <span
              key={tag}
              className="px-2 py-0.5 rounded-md text-xs bg-secondary-100 text-secondary-700"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}